import { Link } from 'react-router-dom';
import './LegalPage.css';

export default function TermsPage() {
  return (
    <div className="lp-page">

      <header className="lp-header">
        <div className="lp-inner">
          <h1 className="lp-header__h1">Terms of Service</h1>
          <p className="lp-header__meta">Essential Management Ltd · propertytraining.ai</p>
        </div>
      </header>

      <main className="lp-body">
        <div className="lp-inner">

          <section className="lp-section">
            <h2 className="lp-section__heading">1. About these terms</h2>
            <p className="lp-section__body">
              These terms govern your use of propertytraining.ai and your purchase of the
              course delivered through it. The site and the course are operated by Essential
              Management Ltd. By creating an account or buying the course, you agree to
              these terms.
            </p>
          </section>

          <section className="lp-section">
            <h2 className="lp-section__heading">2. The course</h2>
            <p className="lp-section__body">
              When you buy the course, we grant you a non-transferable, non-exclusive licence to access the lessons and downloadable resources for your personal use for 90 days. You may not share your account, copy the videos, redistribute the resources, or use the course content to deliver training to others
            </p>
          </section>

          <section className="lp-section">
            <h2 className="lp-section__heading">3. Educational content, not advice</h2>
            <p className="lp-section__body">
              The course is general educational content about buy-to-let property in
              England. It is not legal, financial, tax or investment advice and is not a
              substitute for advice from a qualified solicitor, accountant, mortgage broker
              or financial adviser on your specific circumstances. Property markets carry
              risk — the value of property can fall, tenants can default, and laws can
              change. You make your own decisions based on your own circumstances.
            </p>
          </section>

          <section className="lp-section">
            <h2 className="lp-section__heading">4. Payment and pricing</h2>
            <p className="lp-section__body">
              The course is sold for a one-off payment in pounds sterling. The current
              price is shown at checkout. Payments are processed by Stripe. We may change
              the price for future buyers, but the price you paid is the price you paid —
              there are no hidden charges and no recurring fees.
            </p>
          </section>

          <section className="lp-section">
            <h2 className="lp-section__heading">5. Refunds</h2>
            <p className="lp-section__body">
              We offer a 14-day refund. If the course isn't for you, email us within 14
              days of purchase and we'll refund you in full. The detail is set out in our{' '}
              <Link to="/refund-policy" className="lp-link">Refund Policy</Link>.
            </p>
          </section>

          <section className="lp-section">
            <h2 className="lp-section__heading">6. Your account</h2>
            <p className="lp-section__body">
              You're responsible for keeping your login details secure and for all activity
              on your account. Tell us straight away if you suspect someone else has
              accessed it. We may suspend or close accounts that breach these terms, share
              login details, or attempt to copy or redistribute the course content.
            </p>
          </section>

          <section className="lp-section">
            <h2 className="lp-section__heading">7. Ask Amanda — AI tutor</h2>
            <p className="lp-section__body">
              The course includes an AI tutor ("Ask Amanda") that answers your questions
              in plain English. The tutor is a useful complement to the lessons, but it is
              an AI — it can occasionally be wrong or out of date. Don't treat its answers
              as professional advice on your specific situation.
            </p>
          </section>

          <section className="lp-section">
            <h2 className="lp-section__heading">8. Liability</h2>
            <p className="lp-section__body">
              Nothing in these terms limits our liability where it cannot lawfully be
              limited — for example, for death or personal injury caused by negligence,
              or for fraud. Subject to that, our total liability arising out of or in
              connection with the course is limited to the price you paid for it. We are
              not liable for any indirect or consequential losses, including lost profits
              or losses arising from property purchase decisions you make.
            </p>
          </section>

          <section className="lp-section">
            <h2 className="lp-section__heading">9. Changes to the course</h2>
            <p className="lp-section__body">
              We update lessons from time to time — for example when the law changes.
              The course you have access to is the current version, including any updates
              we make to the modules during the period of your access.
            </p>
          </section>

          <section className="lp-section">
            <h2 className="lp-section__heading">10. Governing law</h2>
            <p className="lp-section__body">
              These terms are governed by the laws of England and Wales, and the courts
              of England and Wales have exclusive jurisdiction over any dispute.
            </p>
          </section>

          <section className="lp-section">
            <h2 className="lp-section__heading">11. Contact</h2>
            <p className="lp-section__body">
              Questions? Email{' '}
              <a href="mailto:amanda@PropertyTraining.ai" className="lp-link">
                amanda@PropertyTraining.ai
              </a>
              .
            </p>
          </section>

        </div>
      </main>

    </div>
  );
}